import api from "./api";

// Tasks API
export const getTasks = async (params = {}) => {
  const { data } = await api.get("/tasks", { params });
  return data;
};

export const getTask = async (id) => {
  const { data } = await api.get(`/tasks/${id}`);
  return data;
};

export const createTask = async (taskData) => {
  const { data } = await api.post("/tasks", taskData);
  return data;
};

export const updateTask = async (id, taskData) => {
  const { data } = await api.put(`/tasks/${id}`, taskData);
  return data;
};

export const deleteTask = async (id) => {
  const { data } = await api.delete(`/tasks/${id}`);
  return data;
};

// Task Categories API
export const getTaskCategories = async () => {
  const { data } = await api.get("/task-categories");
  return data;
};

export const createTaskCategory = async (categoryData) => {
  const { data } = await api.post("/task-categories", categoryData);
  return data;
};

export const seedTaskCategories = async () => {
  const { data } = await api.post("/task-categories/seed");
  return data;
};

// Teams API
export const getTeams = async () => {
  const { data } = await api.get("/teams");
  return data;
};

export const getTeam = async (id) => {
  const { data } = await api.get(`/teams/${id}`);
  return data;
};

export const createTeam = async (teamData) => {
  const { data } = await api.post("/teams", teamData);
  return data;
};

export const updateTeam = async (id, teamData) => {
  const { data } = await api.put(`/teams/${id}`, teamData);
  return data;
};

export const deleteTeam = async (id) => {
  const { data } = await api.delete(`/teams/${id}`);
  return data;
};

// Task Assignees API
export const assignSelfToTask = async (taskId) => {
  const { data } = await api.post(`/tasks/${taskId}/assignees/self`);
  return data;
};

export const unassignSelfFromTask = async (taskId) => {
  const { data } = await api.delete(`/tasks/${taskId}/assignees/self`);
  return data;
};

export const addTaskAssignee = async (taskId, userId) => {
  const { data } = await api.post(`/tasks/${taskId}/assignees`, { userId });
  return data;
};

export const removeTaskAssignee = async (taskId, userId) => {
  const { data } = await api.delete(`/tasks/${taskId}/assignees/${userId}`);
  return data;
};

// Task Comments API
export const getTaskComments = async (taskId) => {
  const { data } = await api.get(`/tasks/${taskId}/comments`);
  return data;
};

export const addTaskComment = async (taskId, content) => {
  const { data } = await api.post(`/tasks/${taskId}/comments`, { content });
  return data;
};

export const deleteTaskComment = async (commentId) => {
  const { data } = await api.delete(`/task-comments/${commentId}`);
  return data;
};

